import { render, staticRenderFns } from "./IrMsbcInvoicesList.vue?vue&type=template&id=d49bfe8c&"
import script from "./IrMsbcInvoicesList.vue?vue&type=script&lang=js&"
export * from "./IrMsbcInvoicesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports